import { ProductCostCurrencyItemSchema } from "./product-cost-currency-item";
import { z } from "zod";

export const ProductCostItemSchema = z.object({
  Id: z.string(),
  Amount: z.number(),
  IsSaaS: z.boolean().optional(),
  IsAnnual: z.boolean().optional(),
  IsMonthly: z.boolean().optional(),
  Currency: ProductCostCurrencyItemSchema.optional(),
});

export type ProductCostItemType = z.infer<typeof ProductCostItemSchema>;
